import { FC, ReactNode, useEffect, useRef } from "react";

import * as UI from "styles/layouts/ExperimentLayout";

interface ExperimentLayoutProps {
  children: ReactNode;
}

const ExperimentLayout: FC<ExperimentLayoutProps> = ({ children }) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (typeof window !== "undefined" && contentRef && contentRef.current) {
      contentRef?.current?.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto",
      });
    }
  });

  return (
    <UI.ExperimentLayout>
      <UI.ExperimentLayoutContent
        id={"experiment-layout-content"}
        ref={contentRef}
      >
        {children}
      </UI.ExperimentLayoutContent>
    </UI.ExperimentLayout>
  );
};

export default ExperimentLayout;
